export default {
  DmSerifDisplayWoff2:
    'https://fonts.gstatic.com/s/dmserifdisplay/v4/-nFnOHM81r4j6k0gjAW3mujVU2B2G_Bx0vrx52g.woff2',
  DmSerifDisplayWoff: require('./dm-serif-display.woff')
}
